<button
  data-dd-action-name="grid-expand-collapse-button.expand-all-button"
  id="expandAll"
  type="button"
  class="btn btn-sm btn-outline mb-0 me-1"
  [disabled]="allExpanded"
  (click)="onExpandAll()"
>
  <i-lucide name="maximize-2"></i-lucide>
  Expand All
</button>
<button
  data-dd-action-name="grid-expand-collapse-button.collapse-all-button"
  id="collapseAll"
  type="button"
  class="btn btn-sm btn-outline mb-0"
  [disabled]="allCollapsed"
  (click)="onCollapseAll()"
>
  <i-lucide name="minimize-2"></i-lucide>
  Collapse All
</button>
